import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight, Sparkles } from "lucide-react";
import { MEDIA, STATS } from "@/data/content";

export const Hero = () => {
  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-end pt-32 pb-16 overflow-hidden">
      <img
        src={MEDIA.hero}
        alt="Architectural sketch"
        className="absolute inset-0 w-full h-full object-cover opacity-70 pencil"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#FAF7F2]/50 via-[#FAF7F2]/75 to-[#FAF7F2]" />
      <div className="absolute inset-0 bg-grid opacity-40 pointer-events-none" />

      {/* Floating amber orb */}
      <div className="absolute -top-40 -left-20 w-[600px] h-[600px] glow-amber float-orb pointer-events-none" />
      <div className="absolute top-10 right-10 w-[400px] h-[400px] glow-teal float-orb pointer-events-none" style={{ animationDelay: "-7s" }} />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 w-full">
        <div className="grid grid-cols-12 gap-6 items-end">
          <div className="col-span-12 lg:col-span-9">
            <div data-testid="hero-eyebrow" className="inline-flex items-center gap-2 mb-8 border border-stone-300 px-3 py-1.5 backdrop-blur-md">
              <Sparkles className="w-3.5 h-3.5 text-[#B8860B]" />
              <span className="text-xs uppercase tracking-[0.25em] text-stone-700">
                Global Technology & HR Consulting · Dubai
              </span>
            </div>

            <h1 data-testid="hero-headline" className="font-display text-stone-900 text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-light leading-[1.02] tracking-tighter mb-8">
              Humanizing
              <br />
              <span className="text-[#B8860B] italic font-extralight">Technology.</span>
            </h1>

            <p data-testid="hero-subtext" className="text-lg md:text-xl text-stone-700 max-w-2xl leading-relaxed mb-10">
              We partner with global enterprises to design, build and operate the systems that respect the humans behind them — across SAP, AI, Cloud, Cybersecurity and HR.
            </p>

            <div className="flex flex-wrap items-center gap-4">
              <Link
                to="/services"
                data-testid="hero-cta-primary"
                className="btn-primary group"
              >
                Explore our practice
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link
                to="/contact"
                data-testid="hero-cta-secondary"
                className="btn-secondary group"
              >
                Start a conversation
                <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
              </Link>
            </div>
          </div>

          <div className="hidden lg:flex col-span-3 flex-col gap-2 text-right justify-end">
            <div className="text-xs uppercase tracking-[0.25em] text-[#B8860B] mb-3">Scroll</div>
            <div className="ml-auto w-px h-24 bg-gradient-to-b from-[#D4AF37] to-transparent beam" />
          </div>
        </div>

        {/* Inline stats strip */}
        <div data-testid="hero-stats" className="mt-24 grid grid-cols-2 md:grid-cols-4 gap-px bg-stone-200 border border-stone-200">
          {STATS.map((s) => (
            <div key={s.label} className="bg-white/90 backdrop-blur-md p-6 md:p-8">
              <div className="font-display text-3xl md:text-4xl text-stone-900 font-light">{s.value}</div>
              <div className="text-xs uppercase tracking-[0.2em] text-stone-500 mt-2">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
